export const SUCCESS = "Success";
export const WARNING = "Warning";
export const ERROR = "Error";
